import React, { createContext, useContext } from 'react';
import { useProjectActions } from '../hooks/useProjectActions';

const ProjectContext = createContext(null);

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

export const ProjectProvider = ({ children, projectVariant, projectType }) => {
  const actions = useProjectActions(projectVariant, projectType);

  return <ProjectContext.Provider value={{ projectVariant, projectType, actions }}>{children}</ProjectContext.Provider>;
};
